import { useSyncExternalStore } from "react";
import { createProjectStore, type ProjectStore } from "./projectStore";
import { emptyProject, type Project } from "./projectFile";

let shared: ProjectStore | null = null;

/** The one project store for this tab. */
export function getProjectStore(): ProjectStore {
  if (!shared) {
    let storage: Storage | null = null;
    try { storage = typeof sessionStorage !== "undefined" ? sessionStorage : null; } catch { storage = null; }
    shared = createProjectStore(storage);
  }
  return shared;
}

const serverProject = emptyProject({ passKey: "server-render-placeholder-key" });

/** The open project; re-renders when any tool changes it. */
export function useProject(): [Project, ProjectStore] {
  const store = getProjectStore();
  const project = useSyncExternalStore(store.subscribe, store.get, () => serverProject);
  return [project, store];
}
